import React from 'react';
import logo from './logo.jpg';
import './App.css';
import Shop from './Shop.js';
import Home from './Home.js';
import { Collapse,
         Navbar,
         NavbarToggler,
         Nav,
         NavItem,
         NavLink } from 'reactstrap';

import { BrowserRouter, Route} from 'react-router-dom';

import {
  faYoutube,
  faFacebook,
  faTwitter,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Countdown from './Countdown.js';


import '../node_modules/react-image-slider/lib/image-slider.css';

function App() {
   
  return (
    <div className="App">
      
      
      <div className='App-landing'>
        <BrowserRouter>
          <div id='routes'>
            <Route exact path='/' component={Home} />
            <Route exact path='/shop'  render={()=>
              <section className="ShopCover">
                <p className="info2">
                <br/>
                  Pazarı ayağınıza getiriyoruz!
                  <br/>
                  👉 Pazar fiyatına
                  👉 İade garantisi
                  👉 Getirme ücreti yok ! 
                </p>
                
                <br/>
                <br/>

                <Shop />
              </section>
            }  />
          </div>
        </BrowserRouter>
      </div>

      <section>
          <footer className='App-footer'>
            <p>&reg; 2018 bikivi</p>
          </footer>
      </section>


      
    </div>
  );
}

export default App;
